// extracted by mini-css-extract-plugin
export default {"container":"TeamStat_container__s2Nar","title":"TeamStat_title__vH1co","value":"TeamStat_value__BGA6k"};